import {Form, Select} from 'antd';
import {motion} from 'framer-motion';
import styles from './simulator.module.scss';
import {CloseOutlined} from '@ant-design/icons';
import SubmitButton from 'components/Startup/components/SubmitButton';

export const SubscriptionsFilter = ({handleFilter, handleClose, form}) => {
  return (
    <motion.div
      className={styles.filterItems}
      initial={{opacity: 0, y: -20, scale: 0.95}}
      animate={{opacity: 1, y: 0, scale: 1}}
      exit={{opacity: 0, y: -20, scale: 0.95}}
      transition={{duration: 0.3, ease: 'easeOut'}}>
      <div className={styles.filterHeader}>
        <h2>Filters</h2>
        <button
          type="button"
          className={styles.closeButton}
          onClick={handleClose}>
          <CloseOutlined style={{fontSize: '24px', color: '#666'}} />
        </button>
      </div>
      <Form
        form={form}
        onFinish={handleFilter}
        layout="vertical"
        className={styles.form}>
        <div className={styles.fieldPair}>
          <Form.Item name="cycle" label="Cycle">
            <Select allowClear placeholder="Select cycle">
              <Select.Option value="MONTHLY">Monthly</Select.Option>
              <Select.Option value="YEARLY">Yearly</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="channel" label="Channel">
            <Select allowClear placeholder="Select channel">
              <Select.Option value="WALLET">Wallet</Select.Option>
              <Select.Option value="OTHER">Other</Select.Option>
            </Select>
          </Form.Item>
        </div>
        <div className={styles.fieldPair}>
          <Form.Item name="planType" label="Plan Type">
            <Select allowClear placeholder="Select plan type">
              <Select.Option value="FREE">Free</Select.Option>
              <Select.Option value="PREMIUM">Premium</Select.Option>
            </Select>
          </Form.Item>
        </div>
        <div className={styles.fullWidthField}>
          <Form.Item name="active" label="Status">
            <Select allowClear placeholder="Select status">
              <Select.Option value={true}>Active</Select.Option>
              <Select.Option value={false}>Inactive</Select.Option>
            </Select>
          </Form.Item>
        </div>
        <div className={styles.submitArea}>
          <SubmitButton label="Apply Filters" />
        </div>
      </Form>
    </motion.div>
  );
};
